import { render, staticRenderFns } from "./trendSetterList.vue?vue&type=template&id=f437b6e6"
import script from "./trendSetterList.vue?vue&type=script&lang=js"
export * from "./trendSetterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f437b6e6')) {
      api.createRecord('f437b6e6', component.options)
    } else {
      api.reload('f437b6e6', component.options)
    }
    module.hot.accept("./trendSetterList.vue?vue&type=template&id=f437b6e6", function () {
      api.rerender('f437b6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/redBook/component/trendSetterList.vue"
export default component.exports